import React from 'react';
import { themeColors } from '../../constants/design';

const LoadingSpinner = ({ fullScreen = false }) => (
  <div className={`flex justify-center items-center ${fullScreen ? 'h-screen' : 'h-full'}`}>
    <div className={`animate-spin rounded-full h-12 w-12 border-b-2 ${themeColors.primary.border}`}></div>
  </div>
);

export default LoadingSpinner;
